<div class="app-photodoc modal-body content width-400 height-400">
  <div class="layout-auto-1-auto">
    <div *ngIf="isHeader" class="modal-header">
      Kopfzeile bearbeiten
    </div>
    <div *ngIf="!isHeader" class="modal-header">
      Fußzeile bearbeiten
    </div>
    <div class="content">
      <exg-textarea [(ngModel)]="commentModel"></exg-textarea>
    </div>
    <div class="spawn-modal-actions typo-small">
      <button (click)="save()"
              class="md-btn">
        Speichern
      </button>
      <button (click)="close()" class="md-btn">
        Abbrechen
      </button>
    </div>
  </div>
</div>
